customElements.define("product-dimensions", class extends HTMLElement {
    // The constructor is called when the element is created.
    constructor() {
        super();
    }

    // The connectedCallback is called when the element is added to the DOM.
    connectedCallback() {
        document.addEventListener("variant_changed", (event) => {
            this.render(event?.detail);
        })

        document.addEventListener("DOMContentLoaded", () => {
            try {
                const dimensions = this.dataset.variantAttributes;
                const parsedDimensions = JSON.parse(dimensions);
                this.render({ dimensions: parsedDimensions });
            } catch (e) {
                console.error(e)
            }
        })

    }

    hideShowAccordion(dimensions) {
        const id = this.dataset.accordionId
        const accordion = document.getElementById(id)

        accordion.style.display = !dimensions || (
                !dimensions?.height &&
                !dimensions?.length &&
                !dimensions?.width &&
                !dimensions?.materials &&
                !dimensions?.weight
            ) ? 'none' : 'block'
    }

    render(data) {
        const s = dimensionStrings || false;

        const { height, length, width, capacity, materials, weight } = data?.dimensions;

        this.hideShowAccordion(data?.dimensions)

        this.innerHTML = `
            <div class="product-dimensions">
                ${weight ? `
                    <div class="product-dimensions__item">
                        <span class="product-dimensions__item__label">${s?.productWeight}:</span>
                        <span class="product-dimensions__item__value">${weight}</span>
                    </div>
                ` : ``}
                ${height && length && width ? `
                    <div class="product-dimensions__item">
                        <span class="product-dimensions__item__label">${s?.productDimensions}:</span>
                        <span class="product-dimensions__item__value">
                            ${height}${s?.inches} x
                            ${width}${s?.inches} x
                            ${height}${s?.inches}
                        </span>
                    </div>
                ` : ``}
                ${capacity ? `
                    <div class="product-dimensions__item">
                        <span class="product-dimensions__item__label">${s?.productCapacity}:</span>
                        <span class="product-dimensions__item__value">${capacity}</span>
                    </div>
                ` : ``}
                ${materials ? `
                    <div class="product-dimensions__item">
                        <span class="product-dimensions__item__label">${s?.productMaterials}:</span>
                        <span class="product-dimensions__item__value">${materials}</span>
                    </div>
                ` : ``}
                <p>${s?.empty}</p>
            </div>
        `;
    }
})